$(".two-line-input-handler").on('focus blur', function(event) {
    if (event.type == 'focus') {
        $(this).prev().addClass("input-set-visible-labne");
        $(this).addClass('input-set-padding');
    } else {
        if (!$(this).val()) {
            $(this).prev().removeClass("input-set-visible-labne");
            $(this).removeClass('input-set-padding');
        }
    }
});